import { useState } from 'react';
import gql from 'graphql-tag';
import useQueryFacade from '../useQueryFacade';
import { apolloClient } from '../../src/apollo';
import { isSeller } from '../useCustomerTools';

const queryStructure = `total
results {
  id
  version
  createdAt
  quoteRequestState
  comment
  customer {
    id
    email
    firstName
    lastName
    customerGroup {
        id
    }
  }
  lastModifiedBy {
    clientId
    isPlatformClient
  }
  createdBy {
    clientId
    isPlatformClient
  },
  totalPrice {
    centAmount
    currencyCode
    fractionDigits
  }
}`;

const buyerQuery = gql`
  query MyQuoteRequests($limit: Int, $offset: Int, $where: String) {
    me {
      quoteRequests(limit: $limit, offset: $offset, sort: "createdAt desc", where: $where) {
        ${queryStructure}
      }
    }
  }
`;

const sellerQuery = gql`
  query QuoteRequests($limit: Int, $offset: Int, $where: String) {
      quoteRequests(limit: $limit, offset: $offset, sort: "createdAt desc", where: $where) {
        ${queryStructure}
      }
  }
`;

const deleteQuoteRequestMutation = gql `
  mutation deleteQuoteRequest($version: Long!, $id: String) {
    deleteQuoteRequest(version: $version, id: $id) {
      id
    }
  }
`;

const cancelQuoteRequestMutation = gql `
  mutation cancelQuoteRequest($version: Long!, $id: String!) {
    updateQuoteRequest(
        actions: [{
            changeQuoteRequestState: {
                quoteRequestState: Cancelled
            }
        }], 
        version: $version,
        id: $id
        ) {
      id
    }
  }
`;

function useMyQuotes({limit, offset}) {
    const [quotes, setQuotes] = useState(null);
    const [total, setTotal] = useState(null);
    const isSellerUser = isSeller();
    const query = isSellerUser ? sellerQuery : buyerQuery;
    const { loading, refetch } = useQueryFacade(query, {
        variables: { limit, offset, where: "quoteRequestState not in (\"Cancelled\", \"Closed\")" },
        onCompleted: (data) => {
          if (!data) {
            return;
          }
          if(isSellerUser) {
            setQuotes(data.quoteRequests.results)
            setTotal(data.quoteRequests.total);
          } else {
            setQuotes(data.me.quoteRequests.results)
            setTotal(data.me.quoteRequests.total);
          }
        },
      });

      const deleteQuoteRequest = (quote) => {
          return apolloClient
          .mutate({
            mutation: deleteQuoteRequestMutation,
            variables: {
              version: quote.version,
              id: quote.id
            },
          })
          .then(resp=> {
            refetch();
            return resp;
          })
      }

      const cancelQuoteRequest = (quote) => {
        return apolloClient
        .mutate({
          mutation: cancelQuoteRequestMutation,
          variables: {
            version: quote.version,
            id: quote.id
          },
        })
        .then(resp=> {
          refetch();
          return resp
        })
      }

    return {quotes, total, loading, deleteQuoteRequest, cancelQuoteRequest}
}

export default useMyQuotes;